<template>
    <fieldset v-cr-custom-validation="validationMessage" tabindex="-1">
        <legend class="cr-mb4">{{ challenge.description }}</legend>
        <cr-checkbox
            v-for="choice in challenge.choice.values"
            :key="choice.id"
            name="choice"
            :label="choice.text"
            :modelValue="isChecked(choice.id)"
            @update:model-value="onChoiceChecked(choice.id)"
            :disabled="disabled"
        />
    </fieldset>
</template>
<style scoped>
.cr-checkbox
{
    font-size: var(--cr-input-text-size);
}
.cr-checkbox :deep(input)
{
    border-color: var(--cr-text);
}
.cr-checkbox :deep(input:focus-visible)
{
    border-color: var(--cr-black);
}
</style>

<script setup lang="ts">
import { IChallenge } from '@cyber-range/cyber-range-api-ctf-challenge-client';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const props = defineProps<{ 
    challenge: IChallenge; 
    disabled?: boolean; 
}>();

const model = defineModel<string[]>({ default: () => [] });

const validationMessage = computed(() => model.value.length > 0 ? '' : t('CHALLENGE_FORM_MULTIPLE_SELECT_VALIDATION_MESSAGE'));

const isChecked = (choiceId:string) => model.value.includes(choiceId);
function onChoiceChecked(choiceId:string) {
    if (isChecked(choiceId))
    {
        model.value = model.value.filter(id => id !== choiceId);
    }
    else
    {
        model.value = [...model.value, choiceId];
    }
}
</script>
